<avano-panel
  [headerText]="translationKeys.articleCategorySelectDialogComponent.html.availableArticleCategories | translate"
  [noPadding]="true"
  [avanoLoadingIndicator]="blockingIdentifier"
>
  <div class="search-bar-grid">
    <div class="search-bar-col">
      <a href="https://www.tariffnumber.com/" target="_blank">{{ translationKeys.articleCategoryTreeComponent.html.href | translate }}</a>
    </div>
    <div class="search-bar-col search-div">
      <p-dropdown class="search-options-dropdown" [options]="searchOptions" [(ngModel)]="searchMode"> </p-dropdown>
      <input
        class="search-input"
        type="text"
        avanoInputText
        (keyup.enter)="search()"
        [(ngModel)]="searchTerm"
      />
      <button
        class="search-button"
        avanoButton
        [callToAction]="true"
        icon="icon-content-search"
        [label]="translationKeys.articleCategoryTreeComponent.html.button.search | translate"
        (click)="search()"
      ></button>
    </div>
  </div>

  <p-treeTable
    [value]="mainTree"
    [columns]="cols"
    selectionMode="single"
    [(selection)]="selectedNode"
    [lazy]="true"
    (onNodeExpand)="onExpand($event)"
    [scrollable]="true"
    scrollHeight="flex"
    styleClass="article-category-tree-table"
    (onNodeSelect)="nodeSelect($event)"
    (onNodeUnselect)="nodeUnselect()"
  >
    <ng-template pTemplate="emptymessage">
      {{ translationKeys.articleCategoryTreeComponent.html.noSearchResults | translate }}
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th *ngFor="let col of cols" [style.width]="col.width + '%'">
          {{ col.header | translate }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
      <tr [ttRow]="rowNode" [ttSelectableRow]="rowNode">
        <td *ngFor="let col of columns; let i = index" [style.width]="col.width + '%'">
          <div class="cell-entry">
            <p-treeTableToggler [rowNode]="rowNode" *ngIf="i === 0"></p-treeTableToggler>
            <span>{{ rowData[col.field] }}</span>
          </div>
        </td>
      </tr>
    </ng-template>
  </p-treeTable>
</avano-panel>
